import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { getPost, updatePost } from '../api/posts';

const EditPost = () => {
    const { id } = useParams();
    const navigate = useNavigate();
    const [title, setTitle] = useState('');
    const [content, setContent] = useState('');

    useEffect(() => {
        getPost(id).then((post) => {
            setTitle(post.title);
            setContent(post.content);
        });
    }, [id]);

    const handleSubmit = async (e) => {
        e.preventDefault();
        await updatePost(id, { title, content });
        navigate(`/post/${id}`);
    };

    return (
        <div>
            <h1>Edit Post</h1>
            <div className="card">
                <form onSubmit={handleSubmit}>
                    <div className="form-group">
                        <label className="form-label">Title</label>
                        <input
                            type="text"
                            className="form-control"
                            value={title}
                            onChange={(e) => setTitle(e.target.value)}
                        />
                    </div>
                    <div className="form-group">
                        <label className="form-label">Content</label>
                        <textarea
                            className="form-control"
                            value={content}
                            onChange={(e) => setContent(e.target.value)}
                        />
                    </div>
                    <button type="submit" className="btn btn-primary">Update Post</button>
                </form>
            </div>
        </div>
    );
};

export default EditPost;
